/**
 * HomePage — tableau de bord atelier (S6 PR5).
 *
 * Sections empilées indépendantes (4 useQuery) → isolation des pannes :
 * si une section échoue (500 BE), les autres continuent à s'afficher.
 *
 *   1. Masthead (titre + date du jour)
 *   2. AlertBar (tokens 30/15/7j, queue failed, polling failed, scheduler stale)
 *   3. KpisRow (sales 30j, listings actifs, queue, favorites cumulés)
 *   4. ActivityFeed + SignalsPanel (2 colonnes desktop, stacked mobile)
 *
 * Pas d'agrégateur unique côté BE par design (cf.
 * `dashboard_service.py` docstring) — chaque section a son endpoint.
 */

import ActivityFeed from '@/components/dashboard/ActivityFeed'
import AlertBar from '@/components/dashboard/AlertBar'
import KpisRow from '@/components/dashboard/KpisRow'
import SignalsPanel from '@/components/dashboard/SignalsPanel'
import Page from '@/components/layout/Page'

import './HomePage.css'

export default function HomePage() {
  const todayLabel = new Date().toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

  return (
    <Page>
      <Page.Header title="Tableau de bord" subtitle={`Atelier sgraphic · ${todayLabel}`} />

      <AlertBar />
      <KpisRow />

      <div className="home-page-grid">
        <ActivityFeed />
        <SignalsPanel />
      </div>
    </Page>
  )
}
